<template>
  <div class="code">
    <div class="code-input">
      <el-input v-model="base64" type="textarea" :rows="14" placeholder="请输入编码 / 解码的内容" />
      <el-input v-model="str" type="textarea" :rows="14" placeholder="编码 / 解码结果" />
    </div>
    <div class="code-btn">
      <el-button type="primary" @click="encrypt">BASE64编码</el-button>
      <el-button type="primary" @click="decrypt">BASE64解码</el-button>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
export default {
  data () {
    return {
      base64: '',
      str: ''
    }
  },
  methods: {
    encrypt () {
      if (this.base64 == '') return
      this.str = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(this.base64))
    },
    decrypt () {
      if (this.base64 == '') return
      this.str = CryptoJS.enc.Base64.parse(this.base64).toString(CryptoJS.enc.Utf8)
    }
  }
}
</script>

<style lang="stylus" scope>
.code
  .code-input
    .el-textarea
      width 590px
    .el-textarea:last-child
      float right
  .code-btn
    margin-top 22px  

</style>